import Backbone from "backbone";
import $ from "jquery";
import SharedDispatcher from "../others/SharedDispatcher";
import SymbolTemplate from "../../../templates/Symbol.mustache";
import {symbolsURL} from "../others/Configuration";

// TMP fix to force the presence in the document
if (!document.getElementsByClassName("js-Overlay").length) {
  document.body.insertAdjacentHTML("beforeend", `<div class="Overlay js-Overlay"><div class="fnac-loader js-OverlaySpinner">${SymbolTemplate.render({ClassName: "fnac-loader-svg", SymbolsUrl: symbolsURL, SymbolName: "icon_i_290_loader"})}</div></div>`);
}

// Possible modifiers: all, menu, menuTab, header (see OverlayView.less)
  //
  // Example:
  // SharedDispatcher.trigger("overlay:show", { cssModifier: 'all', spinner: true })
  // SharedDispatcher.trigger("overlay:hide")

export default Backbone.View.extend({
    initialize: function() {
      this.$spinner = this.$(".js-OverlaySpinner");
      this.isVisible = false;
      this.hasSpinner = false;
      this.currentClass = '';

      this.listenTo(SharedDispatcher, "overlay:show", this.show);
      this.listenTo(SharedDispatcher, "overlay:hide", this.hide);
    },

    events: {
      "click": "triggerClick"
    },

    triggerClick: function() {
      SharedDispatcher.trigger("overlay:click");
    },

    show: function(options) {
      if (options && options.cssModifier) {
        this.currentClass = "Overlay--" + options.cssModifier;
      } else {
        this.currentClass = "";
      }
      // I was forced by zeller to do that
      if($("#communautaire").length) {
        $(".Main-marketingHeader").addClass("withNewHeader");
      }

      this.hasSpinner = !(options && options.noSpinner);

      this.isVisible = true;
      this.render();
    },

    hide: function() {
      this.isVisible = false;
      this.render();
      // I was forced by zeller to do that
      if($("#communautaire").length) {
        $(".Main-marketingHeader").removeClass("withNewHeader");
      }
    },

    render: function() {
      if (this.isVisible) {
        this.$spinner.css("display", this.hasSpinner ? "": "none");
        this.$el.addClass("Overlay--visible " + this.currentClass);
      } else {
        this.$el.removeClass("Overlay--visible " + this.currentClass);
      }
    }
  })
